/*
 * @Author: changcheng
 * @LastEditTime: 2024-01-10 16:34:01
 */
import { useState } from "react";
import {
  querySpecialClassificationDataByLiveWeb,
  queryStartLiveCourseList,
  queryInComingLiveCourseList,
  queryReplayLiveCourseList,
} from "@root/common/service";
import banner from "@root/img/liveBanner.png";
import { Pagination, notification, PageHeader } from "antd";
import { SmileOutlined } from "@ant-design/icons";
import "./_style.scss";
import LiveList from "@root/components/livelist";
import { useEffect } from "react";
import reportQr from "@root/img/reportQr.jpg";
const pageSize = 12;
export default function LivePlatform() {
  const [treeData, setTreeData] = useState([]);
  const [total, setTotal] = useState(1);
  const [secondCategoryId, setSecondLevelId] = useState<any>("");
  const [startList, setStartLiveList] = useState([]);
  const [inComingLiveList, setInComingLiveList] = useState([]);
  const [replayLiveList, setReplayLiveList] = useState([]);
  // 获取正在直播的数据
  const queryStartLiveList = async (page = 1) => {
    const {
      data: { rows = [] },
    } = await queryStartLiveCourseList(
      {
        pageNum: page,
        pageSize,
      },
      secondCategoryId
    );
    setStartLiveList(rows);
  };
  // 获取直播预告数据
  const queryInComingLiveList = async (page = 1) => {
    const {
      data: { rows = [] },
    } = await queryInComingLiveCourseList(
      {
        pageNum: page,
        pageSize,
      },
      secondCategoryId
    );
    setInComingLiveList(rows);
  };
  // 获取直播回放数据
  const queryReplayLiveList = async (page = 1) => {
    const {
      data: { rows = [], total },
    } = await queryReplayLiveCourseList(
      {
        pageNum: page,
        pageSize: 12,
      },
      secondCategoryId
    );
    setReplayLiveList(rows);
    setTotal(total);
  };
  /**
   * 处理专项数据
   * @param data
   * @returns
   */
  const handleSpecialData = (data: any) => {
    return data.map((item: { id: number; name: string; children: any[] }) => {
      return {
        label: item.name,
        value: item.id,
        checked: false,
      };
    });
  };
  /**
   * 获取专项分类数据
   */
  const getSpecialClassificationData = async () => {
    const { data = [] } = await querySpecialClassificationDataByLiveWeb();
    setTreeData(handleSpecialData(data));
  };
  useEffect(() => {
    getSpecialClassificationData();
  }, []);
  useEffect(() => {
    queryStartLiveList(1);
    queryInComingLiveList(1);
    queryReplayLiveList(1);
  }, [secondCategoryId]);
  return (
    <div className="course_train_emergency">
      <img
        src={banner}
        alt=""
        className="banner"
        onClick={() => {
          notification.open({
            message: "扫码关注 获取报告",
            description: <img src={reportQr} alt="" width="160" />,
            icon: <SmileOutlined style={{ color: "#108ee9" }} />,
          });
        }}
      />
      <div className="village_radio">
        <h3>直播分类：</h3>
        <p
          className={`${secondCategoryId === "" ? "radio_select" : ""}`}
          onClick={() => {
            // 跳转护理课程
            setSecondLevelId("");
          }}
        >
          全部
        </p>
        {treeData.map(
          (item: { value: number; label: string; children: [] }) => (
            <p
              key={item.value}
              className={`${
                secondCategoryId === item.value ? "radio_select" : ""
              }`}
              onClick={() => {
                setSecondLevelId(item.value);
              }}
            >
              {item.label}
            </p>
          )
        )}
      </div>
      {startList.length > 0 && (
        <div>
          <h3 className="before_slot">正在直播</h3>
          <LiveList data={startList} type="live" />
        </div>
      )}
      {inComingLiveList.length > 0 && (
        <div>
          <h3 className="before_slot">直播预告</h3>
          <LiveList data={inComingLiveList} type="preview" />
        </div>
      )}
      {replayLiveList.length > 0 && (
        <div>
          <h3 className="before_slot">直播回放</h3>
          <LiveList data={replayLiveList} type="replay" />
        </div>
      )}
      <div className="home_page_container">
        <Pagination
          defaultCurrent={1}
          total={total}
          pageSize={12}
          onChange={(page) => {
            queryReplayLiveList(page);
          }}
          showSizeChanger={false}
        />
      </div>
    </div>
  );
}
